import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import ProductListFilter from 'lib/enums/ProductListFilter';

const options = [
  { label: 'Enabled', value: 'enabled' },
  { label: 'Disabled', value: 'disabled' },
];

function InfluenceCampaignStatusFilter({ selectedValue, updateFilters }) {
  return (
    <Form.Group>
      <Form.Label>Influence Campaign Status</Form.Label>
      <Select
        isClearable
        options={options}
        value={options.find(opt => opt.value === selectedValue) || null}
        onChange={opt => updateFilters(ProductListFilter.INFLUENCE_CAMPAIGN_STATUS, opt?.value)}
      />
    </Form.Group>
  );
}

InfluenceCampaignStatusFilter.propTypes = {
  selectedValue: PropTypes.string,
  updateFilters: PropTypes.func,
};

export default InfluenceCampaignStatusFilter;
